import React from "react";

const CrmTextAreaField = ({ label, name, value, onChange, placeholder = "", rows = 3 }) => {
    return (
        <div className="flex flex-col col-span-2 space-y-1">
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            <textarea
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                rows={rows}
                className="mt-1 block w-full border rounded-lg p-2 focus:ring-2 focus:ring-[#4DA896] focus:border-[#5a4fbe00]"
            ></textarea>
        </div>
    );
};

export default CrmTextAreaField;
